import { __extends } from "tslib";
import React from 'react';
import { PnmacDullBottomButton } from '../BottomButton';
import PnmacMobileButton from '../Uibutton/MobileButton/Button.js';
import { View, Image, Text, ScrollView, Platform } from 'react-native';
import styles from './PnmacPaperLess.styles.js';
import PnmacUIButton from '../Uibutton';
import { textStyle } from '../v2/theme';
var PnmacPaperLess = /** @class */function (_super) {
  __extends(PnmacPaperLess, _super);
  function PnmacPaperLess(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      paperlessStatus: {
        yearEnd: false,
        monthEnd: false
      },
      modalVisible: false,
      paperLessComplete: false
    };
    return _this;
  }
  PnmacPaperLess.prototype.componentDidMount = function () {
    var paperlessStatus = this.props.paperlessStatus;
    this.setState({
      paperlessStatus: paperlessStatus
    });
  };
  PnmacPaperLess.prototype.render = function () {
    var _this = this;
    var _a;
    var monthly = this.props.monthly;
    var _b = this.props,
      translations = _b.translations,
      loanPreference = _b.loanPreference,
      updateCallBack = _b.updateCallBack,
      closeModal = _b.closeModal;
    return /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flex: 1,
        backgroundColor: "#f5f5f5",
        borderRadius: 10,
        width: '100%',
        height: "100%",
        alignSelf: "center"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 15
      }
    }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Image, {
      style: {
        flex: 1,
        aspectRatio: 2,
        resizeMode: 'contain'
      },
      source: require('../assets/PennyPaperless.png')
    })), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, null, translations === null || translations === void 0 ? void 0 : translations.theEasiestWay), /*#__PURE__*/React.createElement(Text, null, translations === null || translations === void 0 ? void 0 : translations.manageYourMortgage))), monthly && !((_a = this.state.paperlessStatus) === null || _a === void 0 ? void 0 : _a.yearEnd) ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flex: 1,
        width: "100%",
        height: "auto",
        backgroundColor: "#f5f5f5",
        borderRadius: 10
      }
    }, /*#__PURE__*/React.createElement(ScrollView, {
      style: {
        maxHeight: 600
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 15,
        backgroundColor: "#CBEAF5"
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextTitle,
      size: 18,
      bold: true,
      gilroy: true,
      blue: true
    }, translations === null || translations === void 0 ? void 0 : translations.PennyPaperlessLogoLine)), /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 15
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextDescription
    }, translations === null || translations === void 0 ? void 0 : translations.PennyPaperlessAccessStatement)), /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 15
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextDescription
    }, translations === null || translations === void 0 ? void 0 : translations.PennyPaperlessReduceRiskOfTheft)), /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 15,
        textAlign: "center"
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextDescription
    }, translations === null || translations === void 0 ? void 0 : translations.PennyPaperlessSignUp)), /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1,
        justifyContent: "flex-end"
      }
    }, /*#__PURE__*/React.createElement(PnmacDullBottomButton, null, /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: 'contained',
      onPress: function () {
        var obj = loanPreference || [];
        if (obj === null || obj === void 0 ? void 0 : obj.find(function (s) {
          return s.preferenceTypeCode == 300009;
        })) {
          obj.find(function (s) {
            return s.preferenceTypeCode == 300009;
          }).preferenceCode = 300027;
          obj.find(function (s) {
            return s.preferenceTypeCode == 300009;
          }).changed = true;
        } else {
          obj.push({
            preferenceTypeCode: 300009,
            preferenceCode: 300027,
            changed: true
          });
        }
        if (obj === null || obj === void 0 ? void 0 : obj.find(function (s) {
          return s.preferenceTypeCode == 300010;
        })) {
          obj.find(function (s) {
            return s.preferenceTypeCode == 300010;
          }).changed = false;
        }
        var that = _this;
        updateCallBack({
          object: obj
        });
      }
    }, translations === null || translations === void 0 ? void 0 : translations.signUp), /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: 'contained',
      onPress: function () {
        return closeModal({
          tracker: true,
          section: "monthly"
        });
      }
    }, translations === null || translations === void 0 ? void 0 : translations.notNow))))) : !this.state.paperLessComplete ? /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flex: 1,
        width: "100%",
        height: "auto",
        backgroundColor: "#f5f5f5",
        borderRadius: 10
      }
    }, /*#__PURE__*/React.createElement(ScrollView, {
      style: {
        maxHeight: 600
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 15,
        backgroundColor: "#CBEAF5"
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextTitle,
      size: 18,
      bold: true,
      gilroy: true,
      blue: true
    }, translations === null || translations === void 0 ? void 0 : translations.MonthlySatementPaperlessEnrolled)), /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 15,
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextDescription
    }, translations === null || translations === void 0 ? void 0 : translations.GoForYearendPaperless)), /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1,
        padding: 15
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      style: {
        marginRight: 10
      },
      mode: 'contained',
      onPress: function () {
        var obj = loanPreference || [];
        if (obj === null || obj === void 0 ? void 0 : obj.find(function (s) {
          return s.preferenceTypeCode == 300010;
        })) {
          obj.find(function (s) {
            return s.preferenceTypeCode == 300010;
          }).preferenceCode = 300027;
          obj.find(function (s) {
            return s.preferenceTypeCode == 300010;
          }).changed = true;
        } else {
          obj.push({
            preferenceTypeCode: 300010,
            preferenceCode: 300027,
            changed: true
          });
        }
        if (obj === null || obj === void 0 ? void 0 : obj.find(function (s) {
          return s.preferenceTypeCode == 300009;
        })) {
          obj.find(function (s) {
            return s.preferenceTypeCode == 300009;
          }).changed = false;
        }
        var that = _this;
        updateCallBack({
          object: obj
        }).then(function (e) {
          _this.setState({
            paperLessComplete: true
          });
        });
      }
    }, translations === null || translations === void 0 ? void 0 : translations.yesSendMeMy), /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: 'contained',
      onPress: function () {
        return closeModal({
          tracker: true,
          section: "yearly"
        });
      }
    }, translations === null || translations === void 0 ? void 0 : translations.notNow))))) : /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flex: 1,
        width: "100%",
        height: "auto",
        backgroundColor: "#f5f5f5",
        borderRadius: 10
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 15,
        backgroundColor: "#CBEAF5"
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextTitle,
      size: 18,
      bold: true,
      gilroy: true,
      blue: true
    }, translations === null || translations === void 0 ? void 0 : translations.YearlySatementPaperlessEnrolled)), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 20,
        marginBottom: 50
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: 'outlined',
      onPress: function () {
        return closeModal({
          tracker: false,
          section: "end"
        });
      }
    }, translations === null || translations === void 0 ? void 0 : translations.close))));
  };
  return PnmacPaperLess;
}(React.Component);
;
export default PnmacPaperLess;